import type { ErrorRegistryShape } from '../common/common.error';

export const INVESTMENT_ERROR = {
  NOT_FOUND_INVESTMENT: { status: 404, message: 'Investment not found' },
  /** 지분 변동이 있는 D3 투자는 지울 수 없다(먼저 변동을 지운다) */
  CONFLICT_INVESTMENT_IN_USE: { status: 409, message: 'Investment has equity changes' },
  /**
   * 검사와 저장 사이에 다른 요청이 바꿨다 — 고른 펀드 · 라운드 · 펀드 목적이 그사이 지워졌거나,
   * 지우려던 투자에 목적이 새로 연결됐다. 다시 불러와 다시 저장한다
   */
  CONFLICT_INVESTMENT_CHANGED: {
    status: 409,
    message: 'Investment or its references were changed by another request',
  },
} as const satisfies ErrorRegistryShape;
